import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const LegalHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="legal" t={t}>
      <Box mb={3}>
        <H3>Gewerkschaftsmitglied</H3>
      </Box>

      <Box mb={2}>
        <Subtitle>Sie sind Mitglied einer Gewerkschaft?</Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Gewerkschaftsmitglieder erhalten unter Umständen eine vergünstigte Prüfung. Sollte dies zutreffen, erhalten
          Sie am Ende des Bestellvorganges einen Hinweis.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Sollten Sie kein Gewerkschaftsmitglied sein, hat das
          <b>keine negativen Auswirkungen</b>
          auf Ihren Prüfbericht.
        </Subtitle>
      </Box>
    </Trans>
  );
};
export default LegalHelp;
